import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentimaTripleYpsili';
const args = {};

export class PetastiKentimaTripleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
